import { render } from "./WordDisplay.vue?vue&type=template&id=7c81b9ca&ts=true"
import script from "./WordDisplay.vue?vue&type=script&lang=ts"
export * from "./WordDisplay.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__